import React, { useEffect, useState } from 'react';
import httpService from 'services/httpService';
import { useParams, Link } from 'react-router-dom';
import * as constants from "Constants"
import { Breadcrumb } from 'react-bootstrap';
// import { useSelector } from 'react-redux';
// import { GiConsoleController } from 'react-icons/gi';

const LabLeaderboardPage = () => {
  const {courseId, labId} = useParams();
  const [labTitle,setLabTitle]=useState("Lab");
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [programTitles, setProgramTitles] = useState([]);

  useEffect(() => {
    // Fetch leaderboard data
    const fetchData = async () => {
      const url = constants.base_url + `/lab/${labId}/leaderboard`;
      try {
        const response = await httpService.get(url);
        setLeaderboardData(response.data.leaderboard);
        setProgramTitles(response.data.program_titles);
        setLabTitle(response.data.lab_title);
      } catch (error) {
        console.error('Error fetching leaderboard data:', error);
      }
    };
    fetchData();
    const interval = setInterval(()=>{
      fetchData();
    },15000)
    return () => {
      clearInterval(interval);
    }
  }, [labId]);

  return (
    <div className="p-4">
      <Breadcrumb>
          <Breadcrumb.Item href="#">
            <Link to={`/courseware/course/${courseId}/content/labs`}>Labs</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item href="#">
            <Link to={`/courseware/course/${courseId}/content/labs/${labId}/`}>
              {labTitle || "lab"}
            </Link>
          </Breadcrumb.Item>
      </Breadcrumb>
     
      <h1 className="text-2xl font-bold mb-4 text-center">{labTitle} Leaderboard</h1>
      <div className="overflow-x-auto rounded-lg shadow-lg mt-4">
        <table className="min-w-full border-collapse border border-gray-300 text-sm text-left text-gray-700 bg-white">
          <thead className="bg-indigo-100 text-gray-900 sticky top-0 z-10">
            <tr>
              <th className="p-3 border border-gray-300 font-semibold text-center">Rank</th>
              <th className="p-3 border border-gray-300 font-semibold text-center">Roll Number</th>
              <th className="p-3 border border-gray-300 font-semibold text-center">Student Name</th>
              {programTitles.map((title, index) => (
                <th key={index} className="p-3 border border-gray-300 font-semibold text-center">
                  {title}
                </th>
              ))}
              <th className="p-3 border border-gray-300 font-semibold text-center">Total Marks</th>
            </tr>
          </thead>
          <tbody>
            {leaderboardData.map((student, index) => {
              

              return (
                <tr
                  key={student.id}
                  className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} hover:bg-indigo-50 transition`}
                >
                  <td className="p-3 border border-gray-300 text-center">{index + 1}</td>
                  <td className="p-3 border border-gray-300 text-center">{student.roll_number}</td>
                  <td className="p-3 border border-gray-300 text-center">{student.name}</td>
                  {programTitles.map((title, i) => (
                    <td key={i} className="p-3 border border-gray-300 text-center">{student[title] || 0}</td>
                  ))}
                  <td className="p-3 border border-gray-300 font-bold text-indigo-700 text-center">{student.total_score}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LabLeaderboardPage;
